export default __webpack_public_path__ + "static/media/baby.4a85c005.svg";